import { render } from "./resume_orders.vue?vue&type=template&id=6979601a"
import script from "./resume_orders.vue?vue&type=script&lang=js"
export * from "./resume_orders.vue?vue&type=script&lang=js"

import "./resume_orders.vue?vue&type=style&index=0&id=6979601a&lang=css"

import exportComponent from "D:\\proyectos_repositorio_institucional\\ed4\\ed4Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__